import { createContext } from 'react';

export const DcContext = createContext(null);
